import React, {useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import SupplierAwardForm from "./SupplierAwardForm";
import SupplierCertificationForm from "./SupplierCertificationForm";
import ProfileAwardRow from "../../profiles/components/ProfileAwardRow";
import ProfileCertificationRow from "../../profiles/components/ProfileCertificationRow";

const SupplierAwardsStep = ({supplierOrg, onSave, onChange, ...props}) => {

    const {auth} = useAuth()
    const [editingIndex, setEditingIndex] = useState(false);
    const getTypeIndex = (type, index) => {
        return `${type}-${index}`
    }
    const getAwardIndex = (index) => {
        return getTypeIndex('award', index)
    }
    const getCertIndex = (index) => {
        return getTypeIndex('cert', index)
    }
    const addNewArrayProp = async (propName) => {

        let models = TB.get({...supplierOrg}, propName, []);
        models.push({});

        await onChange({[propName]: models});
        return setEditingIndex(propName === 'awards' ? getAwardIndex(models?.length - 1) : getCertIndex(models?.length - 1))
    }

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Awards & Certifications
                            </h3>

                            {/*{this.constructor.LastUpdatedMethod && this.renderLastUpdated(this.constructor.LastUpdatedMethod)}*/}
                        </div>

                        <h5 className="form-subtitle">
                            {TB.trans('talent.awards.step_subtitle')}
                        </h5>
                    </div>
                </div>
            </div>

            {TB.map(supplierOrg?.awards || [], (award, awardIndex) => (
                <SupplierFormItemProvider
                    key={`award-${award.id}-${awardIndex}`}
                    itemIndex={awardIndex}
                    preview={<div className="px-4 mx-0 self-start">
                        <ProfileAwardRow award={award}/>
                    </div>}
                    onSave={async (awardsProps) => {

                        if (!awardsProps) {
                            let awards = TB.filter([...supplierOrg?.awards], (awardss, awardsIndex) => {
                                return awardIndex !== awardsIndex;
                            });
                            if (award?.id) {
                                return onSave({awards}, true);
                            }
                            onChange({awards: awards});
                        }else {
                            let awards = TB.set([...supplierOrg?.awards], awardIndex, awardsProps);
                            await onChange({awards});
                            await setEditingIndex(false);
                            onSave({awards}, true);
                        }
                    }}
                    model={award}
                    isUpdating={false}
                    isEditing={editingIndex === getAwardIndex(awardIndex)}
                    onEditing={(toggle) => {
                        setEditingIndex(toggle ? getAwardIndex(awardIndex) : false)
                    }}
                    displayName="Award"
                    itemPropName="awards">

                    <SupplierAwardForm />

                </SupplierFormItemProvider>
            ))}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('awards')}>

                    Add Award #{supplierOrg?.awards?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>

            {TB.map(supplierOrg?.certifications || [], (certification, certificationIndex) => (
                <SupplierFormItemProvider
                    key={`cert-${certification.id}-${certificationIndex}`}
                    itemIndex={certificationIndex}
                    preview={<div className="px-4 mx-0 self-start">
                        <ProfileCertificationRow certification={certification}/>
                    </div>}
                    onSave={async (certificationsProps) => {

                        if (!certificationsProps) {
                            let certifications = TB.filter([...supplierOrg?.certifications], (certificationss, certificationsIndex) => {
                                return certificationIndex !== certificationsIndex;
                            });
                            if (certification?.id) {
                                return onSave({certifications}, true);
                            }
                            onChange({certifications})
                        }else {
                            let certifications = TB.set([...supplierOrg?.certifications], certificationIndex, certificationsProps);
                            await onChange({certifications});
                            await setEditingIndex(false);
                            onSave({certifications}, true);
                        }
                    }}
                    model={certification}
                    isUpdating={false}
                    isEditing={editingIndex === getCertIndex(certificationIndex)}
                    onEditing={(toggle) => {
                        setEditingIndex(toggle ? getCertIndex(certificationIndex) : false)
                    }}
                    displayName="Certification"
                    itemPropName="certifications">

                    <SupplierCertificationForm />

                </SupplierFormItemProvider>
            ))}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('certifications')}>

                    Add Certification #{supplierOrg?.certifications?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>
        </div>
    )
}
export default SupplierAwardsStep